/*
*   Данные и логика по службам доставки
*/
import ajaxRequest from '@/utils/request';

const state = {
    loaded: false,
    deliveries: [],

    editedDeliveryService: {},
    editedManualPvz: {},
    editedManualDeliveryMethod: {}
};

// getters
const getters = {
    deliveries: state => state.deliveries
};

// actions
const actions = {
    loadDeliveryServices(context) {
        return new Promise((resolve, reject) => {
            ajaxRequest({
                url: '/delivery_services/get/',
                success(response) {
                    context.commit('loadDeliveryServices', {
                        deliveries: response.data,
                        resolve
                    });
                }
            });
        });
    },
    loadManualDeliveryMethod(context) {
        let delivery_method_id = context.state.editedManualDeliveryMethod.id;
        if (delivery_method_id) {
            return new Promise((resolve, reject) => {
                ajaxRequest({
                    url: '/delivery_services/delivery_method/manual/get/',
                    params: {
                        delivery_method_id
                    },
                    success(response) {
                        context.commit('selectEditedManualDM', {
                            data: response.data,
                            resolve
                        });
                    }
                });
            });
        }
    },
    changeCityFrom(context, city) {
        // ajaxRequest({
        //     url: '/'
        // })
    },
    switchDeliveryMethod(context, params) {
        return new Promise((resolve, reject) => {
            ajaxRequest({
                url: '/delivery_services/switch_method/',
                method: 'POST',
                params,
                success({data}) {
                    context.commit('switchDeliveryMethod', data);

                    resolve();
                }
            });
        });
    },
    saveDeliveryServiceSetting(context, values) {
        return new Promise((resolve, reject) => {
            ajaxRequest({
                url: '/delivery_services/setting/save/',
                method: 'POST',
                params: values,
                success({data}) {
                    context.commit('saveDeliveryMethodSetting', data);

                    resolve();
                }
            });
        });
    },
    saveManualDM(context, dm) {
        return new Promise((resolve, reject) => {
            ajaxRequest({
                url: '/delivery_services/delivery_method/manual/save/',
                method: 'POST',
                params: dm,
                success({created, data: values}) {
                    context.commit('saveManualDeliveryMethod', {
                        values, created
                    });

                    /* Для того, чтобы работала браузерная кнопочка назад */
                    context.commit('selectEditedManualDM', {data: values});
                    resolve();
                }
            });
        });
    },
    removeManualDM(context, delivery_method_id) {
        return new Promise((resolve, reject) => {
            ajaxRequest({
                url: '/delivery_services/delivery_method/manual/delete/',
                method: 'POST',
                params: {delivery_method_id},
                success(response) {
                    context.commit('removeManualDM', delivery_method_id);

                    resolve();
                }
            });
        });
    },
    saveManualPvz(context, pvz) {
        return new Promise((resolve, reject) => {
            ajaxRequest({
                url: '/tariffs/pvz/manual/save/',
                method: 'POST',
                params: pvz,
                success({created, data}) {
                    context.commit('saveManualPvz', {created, data, resolve});
                },
                failure({errors}) {
                    reject(errors);
                }
            });
        });
    },
    removeManualPvz(context, pvz_id) {
        return new Promise((resolve, reject) => {
            ajaxRequest({
                url: '/tariffs/pvz/manual/delete/',
                method: 'POST',
                params: {pvz_id},
                success(response) {
                    context.commit('removeManualPvz', {pvz_id, resolve});
                }
            });
        });
    }
};

// mutations
const mutations = {
    loadDeliveryServices(state, {resolve, deliveries}) {
        state.deliveries = deliveries;
        state.loaded = true;
        resolve();
    },
    switchDeliveryMethod(state, {id, active}) {
        for (let delivery of state.deliveries) {
            let setting = delivery.delivery_methods.find(item => item.id == id);
            if (setting) {
                setting.active = active;
                break;
            }
        }
    },
    saveDeliveryMethodSetting(state, data) {
        let delivery = state.deliveries.find(item => item.id == data.id);
        for (let k in data) {
            delivery[k] = data[k];
        }
    },
    saveManualDeliveryMethod(state, {values, created}) {
        let ds = state.deliveries.find(item => item.id === values.delivery_service_id);

        if (!created) {
            let prevIndex = ds.delivery_methods.findIndex(item => item.id === values.id);
            ds.delivery_methods.splice(prevIndex, 1);
        }

        let index = ds.delivery_methods.findIndex(item => item.name > values.name);
        ds.delivery_methods.splice(index, 0, values);
    },
    removeManualDM(state, itemId) {
        let delivery = state.deliveries.find(item => item.manual);
        let index = delivery.delivery_methods
            .findIndex(item => item.delivery_method_id === itemId);
        delivery.delivery_methods.splice(index, 1);

        state.editedManualDeliveryMethod.id = null;
        // state.editedManualDeliveryMethod.delivery_type = 'courier'
    },
    saveManualPvz(state, {created, data, resolve}) {
        if (!created) {
            let prevIndex = state.editedManualDeliveryMethod.pvzs
                .findIndex(item => item.id = data.id);
            if (prevIndex !== -1) {
                state.editedManualDeliveryMethod.pvzs.splice(prevIndex, 1);
            }
        }
        let index = state.editedManualDeliveryMethod.pvzs
            .findIndex(item => item.unique_id > data.unique_id);
        state.editedManualDeliveryMethod.pvzs.splice(index, 1, data);

        state.editedManualPvz = data;
        resolve && resolve();
    },
    removeManualPvz(state, {pvz_id, resolve}) {
        let prevIndex = state.editedManualDeliveryMethod.pvzs
            .findIndex(item => item.id = pvz_id);
        if (prevIndex !== -1) {
            state.editedManualDeliveryMethod.pvzs.splice(prevIndex, 1);
        }

        state.editedManualPvz.id = null;
        resolve && resolve();
    },
    selectEditedDeliveryService(state, {data, resolve}) {
        state.editedDeliveryService = data;
        resolve && resolve();
    },
    selectEditedManualDM(state, {data, resolve}) {
        state.editedManualDeliveryMethod = data;
        resolve && resolve();
    },
    selectEditedPvz(state, data) {
        state.editedManualPvz = data;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/deliveryServices.js